// src/components/ForgotPassword.jsx

import React, { useState } from 'react';
import './LoginScreen.css'; // reuse shared styles

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/password-reset/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (!res.ok) throw new Error("Reset request failed");
      setStatus('success');
    } catch (err) {
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
        <div className="login-screen">
            <h2>Forgot Your Password?</h2>
            <form onSubmit={handleSubmit}>
                <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => {
                    setEmail(e.target.value);
                    setStatus(null);
                    }}
                    required
                />
                <button type="submit" disabled={loading}>
                    {loading ? 'Sending…' : 'Send Reset Link'}
                </button>
            </form>

            {/* Reuse the same class as RegisterScreen */}
            <p className="register-link">
                {status === 'success' && <p>Reset link sent. Check your inbox.</p>}
                {status === 'error' && <p style={{ color: 'red' }}>Failed to send reset link.</p>}
            </p>
        </div>
    </div>
  );
}